import React from 'react';
import CustomIcons from 'components/CustomIcons';
import { ICON_NAME } from 'components/CustomIcons/types';

export const SUSPICIOUS_TRANSACTION = 'Suspicious Transactions';

export const FLOWWISE = 'flowwise';
export const EMBEDDABLE_COMPONENTS_KEY = 'embeddable-components';

export const featuresItems = [
  {
    rank: 1,
    key: 'summary',
    icon: iconProps => <CustomIcons componentName="SUMMARY" {...iconProps} />,
    displayText: 'Summary',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'summary/overview',
        displayText: 'Overview',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'summary/analytics',
        displayText: 'Analytics',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 3,
    key: 'settlements',
    icon: iconProps => (
      <CustomIcons componentName="SETTLEMENTS" {...iconProps} />
    ),
    displayText: 'Settlements',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'settlements/standard',
        displayText: 'Standard',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'settlements/vendor',
        displayText: 'Vendor',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 3,
        key: 'settlements/on-demand',
        displayText: 'On-Demand',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      // {
      //   rank: 2,
      //   key: 'settlements/instant',
      //   displayText: 'Instant',
      //   isNew: false,
      //   isDisabled: false,
      //   isVisible: true,
      //   isParent: false,
      // },
    ],
  },
  {
    rank: 2,
    key: 'transactions',
    icon: iconProps => (
      <CustomIcons componentName="TRANSACTIONS" {...iconProps} />
    ),
    displayText: 'Transactions',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 2,
        key: 'transactions/orders',
        displayText: 'Orders',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 4,
        key: 'transactions/disputes',
        displayText: 'Disputes',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
        children: [],
      },
      {
        rank: 1,
        key: 'transactions/payments',
        displayText: 'Payments',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
        children: [],
      },
      {
        rank: 3,
        key: 'transactions/refunds',
        displayText: 'Refunds',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 5,
        key: 'transactions/suspicious',
        displayText: SUSPICIOUS_TRANSACTION,
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
        children: [],
      },
    ],
  },
  {
    rank: 4,
    key: 'vba-configuration',
    icon: iconProps => <CustomIcons componentName="VBA" {...iconProps} />,
    displayText: 'VBA Configuration',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'vba-configuration/accounts',
        displayText: 'VBA Accounts',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'vba-configuration/notification-groups',
        displayText: 'Notification Groups',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 6,
    key: 'payment-links',
    icon: iconProps => (
      <CustomIcons componentName="PAYMENT_LINKS" {...iconProps} />
    ),
    displayText: 'Payment Links',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'payment-links/all',
        displayText: 'All',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'payment-links/orders',
        displayText: 'Orders',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 3,
        key: 'payment-links/batch',
        displayText: 'Batch',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 6,
    key: 'apps',
    icon: iconProps => <CustomIcons componentName="APPS" {...iconProps} />,
    displayText: 'Apps',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
  {
    rank: 5,
    key: 'offers',
    icon: iconProps => <CustomIcons componentName="OFFERS" {...iconProps} />,
    displayText: 'Offers & Recovery',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'offers/all',
        displayText: 'Offers',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'offers/recovery-campaign',
        displayText: 'Recovery Campaign',
        hideHeader: true,
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  // PGDB-3470
  // {
  //   rank: 7,
  //   key: 'qr-code',
  //   icon: iconProps => <CustomIcons componentName="QR_CODE" {...iconProps} />,
  //   displayText: 'QR Code',
  //   isNew: true,
  //   isDisabled: false,
  //   isVisible: true,
  //   isParent: false,
  // },
  {
    rank: 8,
    key: 'customers',
    icon: iconProps => <CustomIcons componentName="CUSTOMERS" {...iconProps} />,
    displayText: 'Customers',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'customers/active',
        displayText: 'Active',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'customers/unfulfilled',
        displayText: 'Unfulfilled',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 9,
    key: 'customisation',
    icon: iconProps => (
      <CustomIcons
        componentName={ICON_NAME.CHECKOUT_CUSTOMISATIONS}
        {...iconProps}
      />
    ),
    displayText: 'Customisation',
    hideHeader: true,
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
];

export const featuresItemsForImportMerchant = [
  {
    rank: 1,
    key: 'summary',
    icon: iconProps => <CustomIcons componentName="SUMMARY" {...iconProps} />,
    displayText: 'Summary',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'summary/overview',
        displayText: 'Overview',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'summary/analytics',
        displayText: 'Analytics',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 2,
    key: 'transactions',
    icon: iconProps => (
      <CustomIcons componentName="TRANSACTIONS" {...iconProps} />
    ),
    displayText: 'Transactions',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'transactions/orders',
        displayText: 'Orders',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 4,
        key: 'transactions/disputes',
        displayText: 'Disputes',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
        children: [],
      },
      {
        rank: 2,
        key: 'transactions/payments',
        displayText: 'Payments',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
        children: [],
      },
      {
        rank: 3,
        key: 'transactions/refunds',
        displayText: 'Refunds',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 5,
        key: 'transactions/suspicious',
        displayText: SUSPICIOUS_TRANSACTION,
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
        children: [],
      },
    ],
  },
  {
    rank: 4,
    key: 'settlements',
    icon: iconProps => (
      <CustomIcons componentName="SETTLEMENTS" {...iconProps} />
    ),
    displayText: 'Settlements',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
  {
    rank: 6,
    key: 'apps',
    icon: iconProps => <CustomIcons componentName="APPS" {...iconProps} />,
    displayText: 'Apps',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
  {
    rank: 5,
    key: 'offers',
    icon: iconProps => <CustomIcons componentName="OFFERS" {...iconProps} />,
    displayText: 'Offers & Recovery',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'offers/all',
        displayText: 'Offers',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'offers/recovery-campaign',
        displayText: 'Recovery Campaign',
        hideHeader: true,
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 8,
    key: 'customers',
    icon: iconProps => <CustomIcons componentName="CUSTOMERS" {...iconProps} />,
    displayText: 'Customers',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'customers/active',
        displayText: 'Active',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'customers/unfulfilled',
        displayText: 'Unfulfilled',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 9,
    key: 'customisation',
    icon: iconProps => (
      <CustomIcons
        componentName={ICON_NAME.CHECKOUT_CUSTOMISATIONS}
        {...iconProps}
      />
    ),
    displayText: 'Customisation',
    hideHeader: true,
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
  {
    rank: 3,
    key: 'payment-verification',
    icon: iconProps => (
      <CustomIcons componentName="PAYMENTS_VERIFICATION" {...iconProps} />
    ),
    displayText: 'Payments Verification',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
];

export const subProductsItems = [
  {
    rank: 3,
    key: 'payment-forms',
    icon: iconProps => (
      <CustomIcons componentName="PAYMENT_FORMS" {...iconProps} />
    ),
    displayText: 'Payment Forms',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'payment-forms/all',
        displayText: 'All',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'payment-forms/orders',
        displayText: 'Orders',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 3,
        key: 'payment-forms/intelli-forms',
        displayText: 'Intelli Forms',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 2,
    key: 'easy-split',
    icon: iconProps => (
      <CustomIcons componentName="EASY_SPLIT" {...iconProps} />
    ),
    displayText: 'Easy Split',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'easy-split/vendors',
        displayText: 'Vendors',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'easy-split/transactions',
        displayText: 'Transactions',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 3,
        key: 'easy-split/refunds',
        displayText: 'Refunds',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 4,
        key: 'easy-split/settlements',
        displayText: 'Settlements',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 5,
        key: 'easy-split/adjustments',
        displayText: 'Adjustments',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 6,
    key: 'softpos',
    icon: iconProps => <CustomIcons componentName="SOFTPOS" {...iconProps} />,
    displayText: 'SoftPOS',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'softpos/collection-point-management',
        displayText: 'Collection Point Management',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'softpos/payment-methods',
        displayText: 'Payment Methods',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 5,
    key: 'product-links',
    icon: iconProps => (
      <CustomIcons componentName="PRODUCT_LINKS" {...iconProps} />
    ),
    displayText: 'Product Links',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
  {
    rank: 4,
    key: 'payment-buttons',
    icon: iconProps => (
      <CustomIcons componentName="PAYMENT_FORMS" {...iconProps} />
    ),
    displayText: 'Payment Buttons',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
  {
    rank: 7,
    key: FLOWWISE,
    icon: iconProps => <CustomIcons componentName="FLOWWISE" {...iconProps} />,
    displayText: 'flowWise',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'flowwise/gateways',
        displayText: 'Gateways',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'flowwise/configurations',
        displayText: 'Configurations',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      // {
      //   rank: 3,
      //   key: 'flowwise/upfront-tdr',
      //   displayText: 'Upfront TDR',
      //   isNew: false,
      //   isDisabled: false,
      //   isVisible: true,
      //   isParent: false,
      // },
      {
        rank: 3,
        key: 'flowwise/settlement-recon',
        displayText: 'Settlement Recon',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 3,
        key: 'flowwise/insights-ai',
        displayText: 'InsightsAI',
        isNew: true,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 8,
    key: EMBEDDABLE_COMPONENTS_KEY,
    icon: iconProps => (
      <CustomIcons
        componentName={ICON_NAME.EMBEDDABLE_COMPONENTS}
        {...iconProps}
      />
    ),
    displayText: 'Embeddable Components',
  },
  {
    rank: 1,
    key: 'one-click-checkout',
    icon: iconProps => (
      <CustomIcons componentName={ICON_NAME.ECOM_360} {...iconProps} />
    ),
    displayText: 'OneClick Checkout',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
  {
    rank: 1,
    key: 'one-click-checkout-pitch',
    icon: iconProps => (
      <CustomIcons componentName={ICON_NAME.ECOM_360} {...iconProps} />
    ),
    displayText: 'OneClick Checkout',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
  {
    rank: 1,
    key: 'one-click-checkout-activated',
    icon: iconProps => (
      <CustomIcons componentName={ICON_NAME.ECOM_360} {...iconProps} />
    ),
    displayText: (
      <>
        One Click <br /> Checkout
      </>
    ),
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'one-click-checkout-activated/funnel-analytics',
        displayText: 'Analytics',
        isNew: false,
        hideHeader: true,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'one-click-checkout-activated/offers',
        displayText: 'Offers & Promotions',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 3,
        key: 'one-click-checkout-activated/shipping-delivery',
        displayText: 'Shipping & Delivery',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 4,
        key: 'one-click-checkout-activated/cod',
        displayText: 'COD & RTO',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 5,
        key: 'one-click-checkout-activated/recovery-campaign',
        displayText: 'Recovery Campaign',
        isNew: false,
        hideHeader: true,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 6,
        key: 'one-click-checkout-activated/customisation',
        displayText: 'Customisation',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
];

export const subProductsItemsForImportMerchant = [
  {
    rank: 1,
    key: 'payment-links',
    icon: iconProps => (
      <CustomIcons componentName="PAYMENT_LINKS" {...iconProps} />
    ),
    displayText: 'Payment Links',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'payment-links/all',
        displayText: 'All',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'payment-links/orders',
        displayText: 'Orders',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 3,
        key: 'payment-links/batch',
        displayText: 'Batch',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    rank: 2,
    key: 'payment-forms',
    icon: iconProps => (
      <CustomIcons componentName="PAYMENT_FORMS" {...iconProps} />
    ),
    displayText: 'Payment Forms',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: true,
    children: [
      {
        rank: 1,
        key: 'payment-forms/all',
        displayText: 'All',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 2,
        key: 'payment-forms/orders',
        displayText: 'Orders',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 3,
        key: 'payment-forms/intelli-forms',
        displayText: 'Intelli Forms',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
];
